
import { defineComponent } from 'vue'
import ContentAdaptLayout from '../../../../_components/content-adapt-layout/content-adapt-layout.vue'

export default defineComponent({
  components: {
    ContentAdaptLayout
  },
  props: {
    id: {
      type: Number,
      default: -1
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
})
